<div class="container-fluid main-container my-5">
  <div class="d-flex">
    <div class="about-main-content">
      <div class="w-70 pt-3 me-2">
        <h5 class="subtitle mt-4">Wie zijn wij?</h5>
        <hr class="horizontal-ruler">
        <p class="info-text mt-2">
          Eén op de 9 mensen in Nederland heeft een beperking.

          Dit kan een verstandelijke of lichamelijke beperking zijn, maar ook bijvoorbeeld een vorm van autisme
          of psychische klachten.
        </p>
        <p class="info-text">
          In de Wet gelijke behandeling handicap of chronische ziekte (Wgbh/cz) staat dat “Mensen met een
          beperking of chronische ziekte net als ieder ander moeten kunnen meedoen.”
        </p>
        <p class="info-text">
          Het klinkt logisch, maar meedoen is alleen mogelijk als je weet wat er voor jou te doen is!
          Vrijwel alle bestaande websites met activiteiten, vakanties en andere leuke dingen, hebben
          één ding gemeen: ze richten zich voornamelijk op mensen zonder beperking.
        </p>
        <p class="info-text">
          Steddie maakt het voor 2 miljoen mensen (hun naasten en begeleiders) heel eenvoudig
          om op zoek te gaan naar activiteiten waarbij rekening wordt gehouden met hun beperking.
          Geen gespeur meer in wijkkrantjes, in besloten groepen of langs allerlei verschillende websites,
          maar alles overzichtelijk op 1 plek. Dat is Steddie!
        </p>
        <b class="contact-text">Over de naam Steddie</b>
        <p class="info-text">
          De naam Steddie is een Nederlandse verbastering van het Engelse ‘steady’ en kan vertaald worden
          als: ‘vast, stabiel, gestaag, regelmatig, evenwichtig en betrouwbaar’.
          De website van Stichting Steddie biedt een betrouwbaar en regelmatig aanbod van verschillende
          activiteiten, gericht op mensen met een beperking.
        </p>
      </div>
      <div class="w-70 mt-3 ms-2">
        <h5 class="subtitle mt-4">Wat is ons doel?</h5>
        <hr class="horizontal-ruler">
        <p class="info-text mt-2">
          <i>‘Een compleet overzicht van alle activiteiten zichtbaar maken voor mensen met een beperking, hun
            begeleiders en hun naasten.’</i>
        </p>
        <p class="info-text mt-4">
          Stichting Steddie is gevestigd in de gemeente Alkmaar en heeft als doel:
        </p>
        <ol type="a">
          <li>
            het promoten van activiteiten (sport, spel, vakanties en dergelijke) voor mensen met een
            beperking;
          </li>
          <li>
            het stimuleren van het organiseren van activiteiten als onder a. bedoeld door het aanbieden
            van expertise aan organisaties;
          </li>
          <li>
            het meer zichtbaar maken van bestaande en toekomstige activiteiten voor mensen met een
            beperking, hun naasten en begeleiders, en het verrichten van al wat hiermee verband houdt
            of daartoe bevorderlijk kan zijn.
          </li>
        </ol>
        <p class="info-text">
          De stichting beoogt het algemeen nut en heeft geen winstoogmerk.
        </p>
        <p class="info-text">
          <a target="_blank" href="assets/uploads/Beleidsplan%202024%20Stichting%20Steddie.pdf">Het actuele beleidsplan vind je hier.</a>
        </p>
        <p class="info-text">
          <a target="_blank" href="assets/uploads/Jaarrekening 2023 Stichting Steddie.pdf">Jaarrekening 2023</a>
        </p>
        <p class="info-text">
          <a target="_blank" href="assets/uploads/Jaarrekening 2024 Stichting Steddie.pdf">Jaarrekening 2024</a>
        </p>
      </div>
    </div>
  </div>
  <h2 class="subtitle mt-4">Bestuur</h2>
  <p class="info-text mt-2">
    Het bestuur van Stichting Steddie is onbezoldigd, onafhankelijk en heeft een onafhankelijke voorzitter.
  </p>
  <table class="board-details">
    <tr>
      <td class="contact-text">Voorzitter:</td>
      <td>dhr. M.K. Fellensiek</td>
    </tr>
    <tr>
      <td class="contact-text">Penningmeester:</td>
      <td>dhr. C.J.M. Flaton</td>
    </tr>
    <tr>
      <td class="contact-text">Secretaris:</td>
      <td>dhr. J.W. Smorenburg</td>
    </tr>
  </table>
</div>
<div class="contact-section">
  <div class="container">
    <h2 class="subtitle mb-4 mb-md-5">Neem contact met ons op</h2>
    <form [formGroup]="contactForm" class="shadow rounded-4 bg-white p-3 p-md-5">
      <div *ngIf="contactErrorMessage" class="alert alert-danger m-auto mb-3" role="alert">
        {{ this.contactErrorMessage }}
      </div>
      <div *ngIf="contactSuccessMessage" class="alert alert-success m-auto mb-3" role="alert">
        {{ this.contactSuccessMessage }}
      </div>
      <div class="row mb-4">
        <div class="col-md-6 mx-auto mb-4 mb-md-0">
          <label for="contact-name" class="form-label fw-semibold">Naam*</label>
          <input type="text" class="form-control form-input" formControlName="name" id="contact-name" required>
          <div class="errors" *ngIf="name?.errors && formSubmitted && !contactSuccessMessage">
            <small class="text-danger" *ngIf="name?.errors?.['required']">Dit veld is vereist.</small>
          </div>
        </div>
        <div class="col-md-6 mx-auto">
          <label for="contact-name" class="form-label fw-semibold">E-mailadres*</label>
          <input type="email" class="form-control form-input" formControlName="email" id="contact-email" required>
          <div class="errors" *ngIf="email?.errors && formSubmitted && !contactSuccessMessage">
            <small class="text-danger" *ngIf="email?.errors?.['required']">Dit veld is vereist.</small>
            <small class="text-danger" *ngIf="email?.errors?.['email']">Voer een geldig emailadres in.</small>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-12">
          <label for="contact-phone" class="form-label fw-semibold">Telefoonnummer</label>
          <input type="text" class="form-control form-input" formControlName="phonenumber" id="contact-phone">
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <label for="contact-message" class="form-label fw-semibold">Bericht*</label>
          <textarea class="form-control form-textarea" id="contact-message" rows="4" formControlName="message" required></textarea>
          <div class="errors" *ngIf="message?.errors && formSubmitted && !contactSuccessMessage">
            <small class="text-danger" *ngIf="message?.errors?.['required']">Dit veld is vereist.</small>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="privacyCheck" formControlName="privacy" required>
            <label class="form-check-label" for="privacyCheck">
              Ik ga akkoord met het <a [routerLink]="['/privacy']">privacybeleid</a>.<span class="required">*</span>
            </label>
            <div class="errors" *ngIf="privacy?.errors && formSubmitted && !contactSuccessMessage">
              <small class="text-danger" *ngIf="privacy?.errors?.['required']">Dit veld is vereist.</small>
            </div>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-primary w-100 p-2 fw-semibold shadow" (click)="sendContactForm()">Versturen</button>
    </form>
  </div>
</div>
